import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import './submitButton.css';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';


class SubmitButton extends Component {

    state = {
        buttonLabel: this.props.initialValues.label || 'Submit',
        bgColor: this.props.initialValues.bgColor || '#387ef5',
        textColor: this.props.initialValues.textColor || '#ffffff',
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            label: this.state.buttonLabel,
            bgColor: this.state.bgColor,
            textColor: this.state.textColor,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setLabel = (e) => {
        this.setState({ buttonLabel: e.target.value });
    };

    setBgColor = (e) => {
        this.setState({ bgColor: e.target.value});
    };

    setTextColor = (e) => {
        this.setState({ textColor: e.target.value});
    };

    render() {
        const { bgColor, textColor, buttonLabel } = this.state;
        return (
            <>
                <AppInputWrapper color={this.props.textColor}>
                    <button
                        disabled={this.props.loadingSubmit}
                        onClick={this.props.handleSubmit}
                        type="button"
                        className="submit-form-btn"
                        style={{
                            backgroundColor: bgColor,
                            color: textColor
                        }}
                    >
                        <span className="button-text">{ buttonLabel }</span>
                        {
                            this.props.loadingSubmit && <span className="loader" />
                        }
                    </button>
                    {
                        this.props.isResultInput && !this.props.formIsValid &&
                        <p className="submission-error">There were errors with your submission, please amend and try again</p>
                    }
                </AppInputWrapper>

                {
                    !this.props.isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <input
                                    onChange={this.setLabel}
                                    type="text"
                                    value={buttonLabel}
                                />
                                label
                            </label>
                            <label style={{ alignSelf: 'flex-start' }}>
                                <input
                                    className="button-bg-color-input"
                                    onChange={this.setBgColor}
                                    type="color"
                                    value={bgColor}
                                />
                                Button color
                            </label>

                            <label style={{ alignSelf: 'flex-start' }}>
                                <input
                                    className="button-text-color-input"
                                    onChange={this.setTextColor}
                                    type="color"
                                    value={textColor}
                                />
                                Button text color
                            </label>
                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(SubmitButton)
